import React from 'react'
import {translate} from 'react-i18next'

import View from 'components/View'
import Title from 'components/Title'
import Note from 'components/Note'
import theme from 'theme'
import * as stringUtils from 'utils/stringUtils'
import LinkWithButton from 'theme/shared/components/LinkWithButton'

const EmailVerifiedMessage = ({t, handleClick, loading}) => {
  const firstName = decodeURIComponent(stringUtils.getFirstName(window.location.search) || '')
  const title = firstName ? t('email-verified.personal-title', {firstName}) : t('email-verified.title')
  const lang = stringUtils.getLang(window.location.search)
  const linkUrl = `${theme.brand.url}${lang}`

  return (
    <View>
      <Title>{title}</Title>
      <Note>{t('email-verified.subtitle')}</Note>
      <LinkWithButton
        to={linkUrl}
        text={t('email-verified.redirect-button')}
        onClick={handleClick && handleClick(linkUrl)}
        loading={loading}
      />
    </View>
  )
}

export default translate()(EmailVerifiedMessage)
